/**
 * Mappers para transformación de datos entre Backend ↔ Frontend
 * Backend devuelve: razon_social, nif, pagina_web, etc.
 * Frontend usa: nombre, cif, web, etc.
 */

/**
 * Mapea datos del backend al formato del frontend (GET Response)
 * @param {Object} installer - Datos del instalador desde el backend
 * @returns {Object} - Datos transformados para el frontend
 */
export const mapBackendInstallerToFrontend = (installer) => {
  if (!installer) return null

  if (installer.encontrado === false) return null

  const source = installer.datos || installer

  if (!source.razon_social && !source.nif) return null

  return {
    id: source.id,
    razon_social: source.razon_social || '',
    nombre: source.razon_social || '',
    cif: source.nif || '',
    nif: source.nif || '',
    email: source.email || '',
    telefono: source.telefono || '',
    web: source.pagina_web || '',
    calle: source.calle || '',
    numero: source.numero || '',
    piso: source.piso || '',
    poligono: source.poligono || '',
    poblacion: source.poblacion || '',
    cod_postal: source.cod_codigo_postal || '',
    cod_codigo_postal: source.cod_codigo_postal || '',
    codigo_postal: source.cod_codigo_postal || '',
    codigo_registro_industrial: source.codigo_registro_industrial || '',
    registro_industrial_id: source.registro_industrial_id || '',
    comunidad_autonoma: source.comunidad_autonoma || source.empresa_ca_id || '',
    empresa_ca_id: source.empresa_ca_id || '',
    activo: source.activo,
    validado: source.validado,
    fecha_creacion: source.fecha_creacion,
    fecha_actualizacion: source.fecha_actualizacion,
  }
}

/**
 * Transforma datos del formulario frontend al formato del backend (POST/PUT Request)
 * Frontend: { nombre, cif, web, ..., registro_industrial_nuevo: { data, name, type } }
 * Backend: { razon_social, nif, pagina_web, ..., registro_industrial: { documento, extension, nombre } }
 *
 * El documento de registro industrial viene ya en base64 desde el FileUploaderAgnostic
 */
export const transformFormStateToBackend = (formState) => {
  const payload = {
    empresa_ca_id: formState.empresa_ca_id,
    razon_social: formState.nombre,
    nif: formState.cif,
    email: formState.email,
    telefono: formState.telefono,
    activo: formState.activo !== undefined ? formState.activo : true,
    calle: formState.calle,
    numero: formState.numero,
    poblacion: formState.poblacion,
    cod_codigo_postal: formState.cod_codigo_postal,
  }

  if (formState.web) payload.pagina_web = formState.web
  if (formState.piso) payload.piso = formState.piso
  if (formState.poligono) payload.poligono = formState.poligono

  // Manejo del documento de registro industrial
  // El archivo viene ya en base64 desde FileUploaderAgnostic con estructura { data, name, type }
  if (formState.registro_industrial_nuevo) {
    const fileDoc = formState.registro_industrial_nuevo
    // Extraer solo la parte base64, sin el prefijo "data:application/...;base64,"
    const base64Data = fileDoc.data.includes(',') ? fileDoc.data.split(',')[1] : fileDoc.data
    payload.registro_industrial = {
      documento: base64Data,
      extension: fileDoc.type,
      nombre: fileDoc.name,
    }
  } else if (formState.registro_industrial_id) {
    // Reutiliza el documento ya existente (p. ej. precargado por la búsqueda por NIF)
    payload.registro_industrial_id = formState.registro_industrial_id
  }

  return payload
}
